<app-container hasFab="true">
  <ng-container>
    <app-fab (clicked)="onAcceptFloating(selectAll)" text="AKCEPTUJĘ"></app-fab>
  </ng-container>

  <mat-card class="container" ngClass.xs="xs">

    <form [formGroup]="consentsForm">
      <div #selectAll fxFlex fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="17px">
        <mat-checkbox
          (change)="selectAllConsents($event.checked)"
          [checked]="allSelected"
          [indeterminate]="indeterminateSelection"
        >
          <b>Zaznacz wszystkie</b>
        </mat-checkbox>

        <div class="checkbox-container flex flex-row">
          <mat-checkbox class="indent" [formControl]="personalDataConsent"></mat-checkbox>
          <div class="consent-text" [class.error]="!personalDataConsent.untouched && personalDataConsent.invalid">
          </div>
        </div>

        <div class="checkbox-container flex flex-row">
          <mat-checkbox class="indent" [formControl]="electronicallySuppliedConsent"></mat-checkbox>
          <div
            class="consent-text"
            [class.error]="!electronicallySuppliedConsent.untouched && electronicallySuppliedConsent.invalid"
          >
          </div>
        </div>

        <div class="checkbox-container flex flex-row">
          <mat-checkbox class="indent" [formControl]="tosConsent"></mat-checkbox>
          <div class="consent-text flex flex-col gap-4" [class.error]="!tosConsent.untouched && tosConsent.invalid">
            <div class="flex flex-row gap-4">
              Zapoznałem się i akceptuję
              <a href="https://payka.pl/legal/220901_payappka_regulamin_TPL.pdf" target="_blank">Regulamin, </a>
              <a
                *ngIf="!tosConsentDetailsVisible"
                class="link"
                (click)="tosConsentDetailsVisible = !tosConsentDetailsVisible"
                >więcej</a
              >
              <a
                *ngIf="tosConsentDetailsVisible"
                class="link"
                (click)="tosConsentDetailsVisible = !tosConsentDetailsVisible"
                >mniej</a
              >
            </div>
            <div *ngIf="tosConsentDetailsVisible">
              <p>
              </p>
            </div>
          </div>
        </div>

        <div class="checkbox-container flex flex-row">
          <div class="consent-text">
          </div>
        </div>

        <div class="checkbox-container flex flex-row">
          <mat-checkbox [formControl]="marketingConsent" class="indent"></mat-checkbox>
          <div class="consent-text">
          </div>
        </div>

        <div class="checkbox-container flex flex-row">
          <div class="consent-text">
            <p>
            </p>
          </div>
        </div>
      </div>
    </form>
  </mat-card>
</app-container>
